import Vue from 'vue';
import SkySticky from './sky-sticky';

Vue.component('sky-sticky', SkySticky);

export default SkySticky;



// WEBPACK FOOTER //
// ./scripts/sky-sticky/index.js